import type { JSONDocNode } from '@atlaskit/editor-json-transformer/types';

/**
 * In-memory, content-scoped "page was just published" signal.
 */
export const pageJustPublishedSignal: {
	contentId: string | null;
	title: string | null;
	adf: JSONDocNode | null;
} = {
	contentId: null,
	title: null,
	adf: null,
};

/**
 * Records that `contentId` (with its published `adf`) was just published, arming any view-page
 * onPublish nudge on the page the user is about to land on. Called from the editor publish flow on a
 * new-page publish.
 */
export const setPageJustPublishedSignal = (
	contentId: string,
	title: string,
	adf: JSONDocNode | null,
): void => {
	pageJustPublishedSignal.contentId = contentId;
	pageJustPublishedSignal.title = title;
	pageJustPublishedSignal.adf = adf;
};
